import Vue from 'vue'
import ViewUI from 'view-design'
import Util from '../libs/util'
import VueRouter from 'vue-router'
// import Cookies from 'js-cookie'
import { routers } from './router'

Vue.use(VueRouter)
// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: routers
}

export const router = new VueRouter(RouterConfig)
export default router
router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start()
  Util.title(to.meta.title)
  // 白名单
  if (Util.localGet('userInfo') && to.name === 'login'&& to.query.accessToken) {
    console.log('00000')
    Util.localSet('accessToken', to.query.accessToken)
    Util.title()
    next({
      name: 'home_index'
    })
  }
  else if (!Util.localGet('userInfo') && to.name !== 'login' && to.name !== 'index' && to.name !== 'opus-detail' && to.name !== 'artical-detail' && to.name !== 'regist' && to.name !== 'practise' && to.name !== 'knowledgeStrong'&& to.name !== 'ULogin'&& to.name !== 'ULoginNeedLogin'&& to.name !== 'accountEnd'&& to.name !== 'ULoginT'&& to.name !== 'zkactivate'&& to.name !== 'pass' && to.name !== 'classCodeLogin' && to.name !== 'uniqueLogin') {
    // 判断是否已经登录且前往的页面不是登录页
    next({
      name: 'login'
    })
  } else if (Util.localGet('userInfo') && to.name === 'login') {
    // console.log(Cookies.get('isBindWeChat'));
    // 判断是否已经登录且前往的是登录页
    Util.title()
    next({
      name: 'home_index'
    })
  } 
  
  else {
    Util.toDefaultPage([...routers], to.name, router, next)
  }
})

router.afterEach((to) => {
  Util.openNewPage(router.app, to.name, to.params, to.query)
  ViewUI.LoadingBar.finish()
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/router/index.js